var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-decoration-none text-no-wrap",attrs:{"href":_vm.sanitizeUrl(_vm.url),"target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"text-decoration-underline"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.url))]})],2),_c('v-icon',{staticClass:"inherit-color ml-1",attrs:{"size":12}},[_vm._v("mdi-open-in-new")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }